import { Post, Put, Delete, Get, url } from "api";
import { PartnerNotificationPayload, NotificationDetails } from "./types";

export const sendNotification = async (
  data: PartnerNotificationPayload & { id?: string }
): Promise<any> => {
  try {
    const endpoint =
      "/dashboard/partner/notifications" + (data.id ? "/" + data.id : "");

    const response = data.id
      ? await Put(endpoint, data)
      : await Post(endpoint, data);

    return response;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error;
  }
};

export const getNotifications = async ({
  page = 1,
  limit = 10,
}: {
  page: number;
  limit: number;
}): Promise<any> => {
  try {
    const response = await Get(
      `/dashboard/partner/notifications?page=${page}&limit=${limit}`
    );
    return response;
  } catch (error) {
    console.error("Error getting notifications:", error);
    throw error;
  }
};

export const getNotificationById = async (
  id: string
): Promise<NotificationDetails> => {
  try {
    const response = await Get(`/dashboard/partner/notifications/${id}`);
    return response;
  } catch (error) {
    console.error("Error getting notification details:", error);
    throw error;
  }
};

export const uploadNotificationImage = async (
  id: string,
  image: File
): Promise<any> => {
  try {
    const arrayBuffer = await image.arrayBuffer();
    const myHeaders = new Headers();
    myHeaders.append(
      "Content-Disposition",
      `attachment;filename=notification.png`
    );
    myHeaders.append("Content-Type", "image/png");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwtToken")
    );

    const response = await fetch(
      `${url}/dashboard/partner/notifications/${id}/image`,
      {
        method: "PUT",
        body: arrayBuffer,
        headers: myHeaders,
      }
    );

    const json = await response
      .clone()
      .json()
      .catch((e) => response.text());

    if (json.err) {
      throw new Error(json.err);
    }

    return json;
  } catch (error) {
    console.error("Error uploading notification image:", error);
    throw error;
  }
};

export const deleteNotification = async (id: string): Promise<any> => {
  try {
    const response = await Delete(`/dashboard/partner/notifications/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting notification:", error);
    throw error;
  }
};

export const getCampaigns = async (params: {
  page: number;
  limit: number;
  search?: string;
}) => {
  try {
    const response = await Get(
      `/dashboard/partner/package-names?page=${params.page}&limit=${
        params.limit
      }&search=${params.search || ""}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    throw error;
  }
};
